import React from 'react';
import styled from 'styled-components';
import { StyledRegister } from '../styles/RegisterForm.styles';
import RegisterProps from '../types/RegisterProps';

const StyledRegisterSuccess = styled(StyledRegister)``;

const RegisterSuccess = (props: RegisterProps) => {
  return (
      <StyledRegisterSuccess>
        <h1>{props.successTitle}</h1>
        <div dangerouslySetInnerHTML={{ __html: props.successText }}></div>
      </StyledRegisterSuccess>
  );
};

export default RegisterSuccess;
